export const GOOGLE_MY_BUSINESS_ERROR_STATUS = {
    UNAUTHORIZED: 'UNAUTHORIZED',
};
